var _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTempreture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 76,
    viewBox: "0 0 75 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.532426,
    y: 0.562699,
    width: 73.9356,
    height: 73.9356,
    rx: 36.9678,
    fill: "#020407",
    fillOpacity: 0.04
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.532426,
    y: 0.562699,
    width: 73.9356,
    height: 73.9356,
    rx: 36.9678,
    stroke: "url(#paint0_linear_706_70418)",
    strokeWidth: 1.07657
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.532426,
    y: 0.562699,
    width: 73.9356,
    height: 73.9356,
    rx: 36.9678,
    stroke: "url(#paint1_linear_706_70418)",
    strokeWidth: 1.07657
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.5153 39.4283V26.3836C38.5153 24.7176 37.1553 23.3633 35.4893 23.3633C33.829 23.3633 32.4747 24.7176 32.4747 26.378V39.4226C30.3383 40.5219 28.9727 42.7489 28.9727 45.1913C28.9727 47.0443 29.7716 48.8123 31.16 50.0476C32.3613 51.1129 33.9083 51.6966 35.5063 51.6966C35.7613 51.6966 36.0163 51.6796 36.2713 51.6513C39.1953 51.3113 41.5867 48.9426 41.9437 46.0129C42.278 43.2703 40.9067 40.6693 38.5153 39.4283ZM35.4889 48.6309C33.5844 48.6309 32.0352 47.0847 32.0352 45.1844C32.0352 43.4766 33.2868 42.0591 34.9219 41.7879V27.1241C34.9219 26.8109 35.1757 26.5574 35.4886 26.5574C35.8015 26.5574 36.0553 26.8109 36.0553 27.1241V41.788C37.6867 42.0594 38.9356 43.4768 38.9356 45.1844C38.9356 47.0847 37.3895 48.6309 35.4889 48.6309Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2581 30.0796H43.6916C44.0045 30.0796 44.2583 29.8262 44.2583 29.513C44.2583 29.1997 44.0045 28.9463 43.6916 28.9463H41.2581C40.9451 28.9463 40.6914 29.1997 40.6914 29.513C40.6914 29.8262 40.9451 30.0796 41.2581 30.0796Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4601 31.2773H42.2962C41.9832 31.2773 41.7295 31.5308 41.7295 31.844C41.7295 32.1572 41.9832 32.4107 42.2962 32.4107H45.4601C45.7731 32.4107 46.0268 32.1572 46.0268 31.844C46.0268 31.5308 45.7731 31.2773 45.4601 31.2773Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6916 33.6084H41.2581C40.9451 33.6084 40.6914 33.8618 40.6914 34.1751C40.6914 34.4883 40.9451 34.7417 41.2581 34.7417H43.6916C44.0045 34.7417 44.2583 34.4883 44.2583 34.1751C44.2583 33.8618 44.0045 33.6084 43.6916 33.6084Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_706_70418",
    x1: -8.17251,
    y1: 4.25897,
    x2: 74.7039,
    y2: 75.0366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#024751",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.323723,
    stopColor: "#024751",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_706_70418",
    x1: 89.8273,
    y1: 91.9749,
    x2: 2.71635,
    y2: 30.2713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#024751"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.544,
    stopColor: "#024751",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTempreture);
export default __webpack_public_path__ + "static/media/tempreture.f5af1432bc34b05ea66ccac64b481c38.svg";
export { ForwardRef as ReactComponent };